module.exports = __webpack_public_path__ + "img/pIndex-about2.c5b87439.jpg";